import React, { Component } from "react";
import { GetBaseUrl } from '@/utils/ConfigHelper'
import axios from 'axios';
import {
  MonsterPointWrapper
} from "./MonsterPoint.style";

import Coupon from '../../../Payment/Charge/paycomponent/coupon';
import { FetchCoupons } from '../../../Interface'

import CouponDetail from '../../../Payment/Charge/paycomponent/coupondetail';
import './MonsterPoint.scss';
import {
  HeaderConatiner,
  HeaderIcon,
  HeaderText
} from "../../Common/Header/Header.style";

import Button from '../../../Common/VMButton';
import i18n from '../../../i18n'

import { connect } from 'react-redux'

class MonsterPointClass extends Component {
  state = {
    couponCodeFromUser: '',
  }

  componentDidMount() {
    const couponCode = sessionStorage.getItem("couponCode")
    if (couponCode) this.setState({ couponCodeFromUser: couponCode.toUpperCase() })
  }

  onCouponCodeFromUserChanged = (e) => {
    this.setState({ couponCodeFromUser: e.target.value.toUpperCase() })
  }

  onRegisterCoupon = async e => {
    e.preventDefault()
    const { couponCodeFromUser } = this.state
    if (!couponCodeFromUser || couponCodeFromUser.length === 0) return

    try {
      const token = localStorage.getItem('token');
      await axios.post(`${GetBaseUrl()}/apis/coupons/issue`, {
        code: couponCodeFromUser
      },
        { headers: { Authorization: `Bearer ${token}` } })
      await FetchCoupons()
      this.setState({ couponCodeFromUser: '' })
      alert(i18n.t('monsterpoint.register.success.text'))
    }
    catch (e) {
      if (e && e.response && e.response.data) {
        const { error_code } = e.response.data
        switch (error_code) {
          case 'ERR_NOT_FOUND': return alert(i18n.t("monsterpoint.register.fail.not.found"))
          case 'ERR_ALREADY_EXIST': return alert(i18n.t("monsterpoint.register.fail.already.exists"))
          default: return alert(i18n.t("monsterpoint.register.fail.text"))
        }
      }
      alert(i18n.t("monsterpoint.register.fail.text"))
    }
    sessionStorage.removeItem("couponCode")
  }
  render() {
    const {
      coupons,
    } = this.props;
    return (
      <MonsterPointWrapper>
        <HeaderConatiner>
          <HeaderIcon src="https://front.videomonster.com/images-u6yd72dy/web/couponIcon.png" />
          <HeaderText>{i18n.t("monsterpoint.title")}</HeaderText>
        </HeaderConatiner>
        <div>
          <form className="monsterpoint-coupon-register mobile-payment-flex" onSubmit={this.onRegisterCoupon}>
            <div
              style={{ display: 'flex', flex: '2', justifyContent: "flex-end" }}
            >
              {i18n.t("monsterpoint.register")}
            </div>
            <input
              className="payment-coupon-input"
              style={{ flex: '6' }}
              type="text"
              placeholder={i18n.t("monsterpoint.input.coupon.number")}
              value={this.state.couponCodeFromUser}
              onChange={this.onCouponCodeFromUserChanged}
              autoComplete="off"
            />
            <Button
              width={this.props.width}
              height={'30px'}
              style={{ background: '#424242' }}
              onClick={this.onRegisterCoupon}
            >
              <div style={{ color: '#fff' }}>{i18n.t("monsterpoint.register.text")}</div>
            </Button>
          </form>
        </div>

        <Coupon />
        <div className="coupon-list-container scroll">
          {coupons && coupons.map((coupon, i) => {
            return (
              <CouponDetail
                key={coupon._id}
                coupon={coupon}
                box={`box${i}`}
              />
            );
          })}
        </div>
      </MonsterPointWrapper>
    );
  }
}

const mapStateToProps = state => ({
  coupons: state.couponStore.coupons
})

export const MonsterPoint = connect(mapStateToProps, null)(MonsterPointClass)